/**
 * Controlul temporal — slider, play/pause, viteză.
 */

let isPlaying = false;
let playTimer = null;
let playSpeed = 1;        // 1×, 2×, 4×
let maxTime = 96;
let onTimeChange = null;

const SPEEDS = [1, 2, 4];
const BASE_INTERVAL_MS = 400;  // interval la 1×

/**
 * Inițializează timeline-ul.
 * @param {number} max - Numărul maxim de timestep-uri
 * @param {function} callback - Funcție apelată la schimbarea timestep-ului (timeIndex)
 * @param {number} [initialValue=0] - Valoarea inițială a slider-ului
 */
export function initTimeline(max, callback, initialValue = 0) {
  maxTime = max;
  onTimeChange = callback;

  const slider = document.getElementById('time-slider');
  slider.max = max;
  slider.value = initialValue;

  slider.addEventListener('input', (e) => {
    const t = parseInt(e.target.value, 10);
    if (onTimeChange) onTimeChange(t);
  });

  // Play/Pause
  document.getElementById('btn-play').addEventListener('click', togglePlay);

  // Viteză
  document.getElementById('btn-speed').addEventListener('click', cycleSpeed);

  // Keyboard shortcuts
  document.addEventListener('keydown', handleKeyboard);
}

/**
 * Actualizează label-urile timeline-ului.
 * @param {number} timeIndex
 * @param {Date[]} dates - Array de Date objects
 * @param {boolean} [isWeather=false] - Dacă e variabilă meteo (pas 3-orar)
 */
export function updateTimelineLabels(timeIndex, dates, isWeather = false) {
  const slider = document.getElementById('time-slider');
  slider.value = timeIndex;

  if (dates && dates[timeIndex]) {
    const d = dates[timeIndex];
    
    // Format detaliat pentru colțul din dreapta jos
    const fmtFull = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'Europe/Bucharest',
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    document.getElementById('time-datetime').textContent = fmtFull.format(d);

    // Format scurt (doar ora) pentru deasupra/lângă slider
    const fmtShort = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'Europe/Bucharest',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    
    // Înlocuim '+Xh' cu ora efectivă
    document.getElementById('time-lead').textContent = `${fmtShort.format(d)}`;
  }
}

/**
 * Toggle play/pause.
 */
export function togglePlay() {
  isPlaying = !isPlaying;
  const btn = document.getElementById('btn-play');
  const iconPlay = document.getElementById('icon-play');
  const iconPause = document.getElementById('icon-pause');

  if (isPlaying) {
    btn.classList.add('playing');
    iconPlay.classList.add('hidden');
    iconPause.classList.remove('hidden');
    startAnimation();
  } else {
    btn.classList.remove('playing');
    iconPlay.classList.remove('hidden');
    iconPause.classList.add('hidden');
    stopAnimation();
  }
}

/**
 * Oprește animația (fără toggle).
 */
export function stopPlay() {
  if (isPlaying) togglePlay();
}

// ── Animație ─────────────────────────────────────────────────────
function startAnimation() {
  stopAnimation();
  const interval = BASE_INTERVAL_MS / playSpeed;

  playTimer = setInterval(() => {
    const slider = document.getElementById('time-slider');
    let t = parseInt(slider.value, 10) + 1;
    if (t > maxTime) t = 0;  // Loop
    if (onTimeChange) onTimeChange(t);
  }, interval);
}

function stopAnimation() {
  if (playTimer) {
    clearInterval(playTimer);
    playTimer = null;
  }
}

function cycleSpeed() {
  const idx = SPEEDS.indexOf(playSpeed);
  playSpeed = SPEEDS[(idx + 1) % SPEEDS.length];
  document.getElementById('btn-speed').textContent = `${playSpeed}×`;

  // Restart animația cu noua viteză dacă e în play
  if (isPlaying) {
    stopAnimation();
    startAnimation();
  }
}

function handleKeyboard(e) {
  // Nu interceptăm dacă e focusat pe un input
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT') return;

  switch (e.key) {
    case ' ':
    case 'k':
      e.preventDefault();
      togglePlay();
      break;
    case 'ArrowRight':
    case 'l': {
      e.preventDefault();
      const slider = document.getElementById('time-slider');
      const t = Math.min(parseInt(slider.value, 10) + 1, maxTime);
      if (onTimeChange) onTimeChange(t);
      break;
    }
    case 'ArrowLeft':
    case 'j': {
      e.preventDefault();
      const slider2 = document.getElementById('time-slider');
      const t2 = Math.max(parseInt(slider2.value, 10) - 1, 0);
      if (onTimeChange) onTimeChange(t2);
      break;
    }
  }
}
